import axios from "axios";
import config from "./config";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND_URL,
  headers: config.headers,
});

export default instance;
